module.exports = __webpack_public_path__ + "static/architecture-71a3a2b748c843fd6fe7aabf57c851eb.png";